import { useTranslate } from "hooks/translation-hooks";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateEventStart } from "redux/actions/eventActions";

export const useAppointmentConfirmation = ({
  jobReference,
  missionOrderId
}) => {
  const t = useTranslate();
  const [moreInformation, setMoreInformation] = useState("");
  const dispatch = useDispatch();
  const successMessage = t("comments_alert-success_message");
  const errorMessage = t("comments_alert-error_message");

  const params = {
    jobReference,
    missionOrderId,
    additional_information: moreInformation,
    successMessage,
    errorMessage
  };

  const confirmCurrentAppointment = () =>
    dispatch(updateEventStart({ status: "APPOINTMENT_CONFIRMED", ...params }));
  const declineCurrentAppointment = () =>
    dispatch(updateEventStart({ status: "APPOINTMENT_DECLINED", ...params }));

  const updateMoreInfo = ({ target: { value } }) => setMoreInformation(value);

  return {
    moreInformation,
    updateMoreInfo,
    confirmCurrentAppointment,
    declineCurrentAppointment
  };
};
